import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { vignettePreview_template } from "./vignettePreview_template";
import { login } from "../../modules/login";
import { isColor, isPercent } from "@amcharts/amcharts4/core";

declare var ko: any;

export class configPromotionsEdit_template extends vnTemplate {

    protected filterLoginStatus: filterDropdown_template;
    protected filterPreimumStatus: filterDropdown_template;
    protected filterListStatus: filterDropdown_template;
    protected presetsFilter: filterDropdown_template;
    protected vignettePreview: vignettePreview_template;

    protected getTemplateHtml(): string {
        return `
            <div class="w-form w-form-large">

                <div class="form-header">
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <input type="checkbox" id="isAvailable" data-bind="checked:isAvailable">
                            <label for="isAvailable" class="form-label icon i-check">Is Available For Use</label>
                        </div>

                         <div class="form-group">
                            <label for="name" class="form-label">Name</label>
                            <input id="name" data-bind="value: name" type="text" class="input-text">
                        </div>

                        <strong class="form-sub-title no-margin">Content</strong>

                        <div class="form-group">
                            <input type="radio" id="custom" data-bind="checked:contentType, checkedValue: 'custom'">
                            <label for="custom" class="form-label icon i-check">Custom HTML & CSS</label>
                        </div>

                         <div class="form-group">
                            <input type="radio" id="presets" data-bind="checked:contentType, checkedValue: 'preset'">
                            <label for="presets" class="form-label icon i-check">Presets</label>
                        </div>
                    </div>

                    <div class="form-body">
                        <div class="form-group">
                            <label for="name" class="form-label">Login User Condition</label>
                            `+ this.filterLoginStatus.getHtmlBuild() +`
                        </div>

                        <div class="form-group">
                            <label for="name" class="form-label">Premium User Condition</label>
                            `+ this.filterPreimumStatus.getHtmlBuild() +`
                        </div>

                        <div class="form-group">
                            <label for="name" class="form-label">List User Condition</label>
                            `+ this.filterListStatus.getHtmlBuild() +`
                        </div>
                    </div>
                </div>

                <div class="w-form-body" data-bind="visible: contentType() === 'custom' ">
                    <div class="form-body">
                        <strong class="form-sub-title no-margin">HTML</strong>
                        <div class="form-group">
                            <label for="" class="form-label">HTML</label>
                            <textarea style="height: 300px" id="htmlEditor" data-bind="value: html, valueUpdate: 'afterkeydown'"></textarea>
                        </div>
                    </div>
                    <div class="form-body">
                        <strong class="form-sub-title no-margin">CSS</strong>
                        <div class="form-group">
                            <label for="" class="form-label">CSS</label>
                            <textarea style="height: 300px" id="cssEditor" data-bind="value: css, valueUpdate: 'afterkeydown'"></textarea>
                        </div>
                    </div>
                </div>

                <div class="form-body" data-bind="visible: contentType() === 'custom' ">
                    <div class="form-body full-width">
                        <strong class="form-sub-title no-margin">Preview</strong>
                        <div class="form-group">
                            `+ this.vignettePreview.getHtmlBuild() +`
                        </div>
                    </div>
                </div>

                <div class="form-body" data-bind="visible: contentType() === 'preset' " style="padding-top: 0;">
                    <div class="w-form-body">
                        <div class="form-body" style="padding-top: 0;">
                            <strong class="form-sub-title no-margin">Presets</strong>
                            <div class="form-group">
                                <label for="name" class="form-label">Presets</label>
                                `+ this.presetsFilter.getHtmlBuild() +`
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                </div>
            </div>
            `;
    }

    protected initPartial(): void {

        this.filterLoginStatus = new filterDropdown_template("filterLoginStatus", this.getTemplateViewModel(), this.caller);
        this.filterLoginStatus.setLabel("Login User");
        this.filterLoginStatus.setOptions([{id : 'null', name: 'Not Applied'}, {id : '1', name: 'Is Logged In'}, {id : '0', name: 'Is Not Logged In'}]);

        this.filterPreimumStatus = new filterDropdown_template("filterPreimumStatus", this.getTemplateViewModel(), this.caller);
        this.filterPreimumStatus.setLabel("Premium User");
        this.filterPreimumStatus.setOptions([{id : 'null', name: 'Not Applied'}, {id : '1', name: 'Is Premium User'}, {id : '0', name: 'Is Not Premium User'}]);

        this.filterListStatus = new filterDropdown_template("filterListStatus", this.getTemplateViewModel(), this.caller);
        this.filterListStatus.setLabel("List Item User");
        this.filterListStatus.setOptions([{id : 'null', name: 'Not Applied'}, {id : '1', name: 'Has 5 Or More Items in Lists'}, {id : '0', name: 'Has Less Than 5 Items in Lists'}]);

        this.presetsFilter = new filterDropdown_template("presetsFilter", this.getTemplateViewModel(), this.caller);
        this.presetsFilter.setLabel("Presets");

        this.vignettePreview = new vignettePreview_template("vignettePreview", this.getTemplateViewModel(), this.caller);
        this.vignettePreview.setShowKeys(true);
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "static"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            isAvailable: ko.observable(true),
            htmlValue: ko.observable(""),
            html: ko.pureComputed(this.htmlComputed(self)),
            cssValue: ko.observable(""),
            css: ko.pureComputed(this.cssComputed(self)),
            contentType: ko.observable("custom"),
            zones: ko.observableArray([]),
            permissions: ko.observableArray(this.initPermissions(['config_promotion'])),
            onClickCancel: function (data, event) {
                self.onClickCancel();

            },
            onClickSave: function (data, event) {
                self.onClickSave()
            }
        }
    }


    protected getTemplateName(): string {

        return "configPromotionEdit_template";
    }

    public getViewModelForRequest() {

        return {
            id: this.getTemplateViewModel().id(),
            name: this.getTemplateViewModel().name(),
            isAvailable: this.getTemplateViewModel().isAvailable(),
            isLoginUser: this.filterLoginStatus.getTemplateViewModel().selectedOption,
            isPremiumUser: this.filterPreimumStatus.getTemplateViewModel().selectedOption,
            has5ListItemsOrMore: this.filterListStatus.getTemplateViewModel().selectedOption,
            html: this.getTemplateViewModel().html(),
            css: this.getTemplateViewModel().css(),
            contentType: this.getTemplateViewModel().contentType(),
            idPreset: this.presetsFilter.getTemplateViewModel().selectedOption
        }
    }

    protected htmlComputed(self) {
        return {
            read: function() {
                return self.getTemplateViewModel().htmlValue();
            },
            write: function(value) {
                self.getTemplateViewModel().htmlValue(value);
                self.vignettePreview.setHtml(value);
            }
        }
    }

    protected cssComputed(self) {
        return {
            read: function() {
                return self.getTemplateViewModel().cssValue();
            },
            write: function(value) {
                self.getTemplateViewModel().cssValue(value);
                self.vignettePreview.setCss(value);
            }
        }
    }

    public setZones(zones){

        this.getTemplateViewModel().zones(zones);
    }

    public setPresetOptions(presets){

        //add the default preset
        presets.unshift({id : '', name: 'Select Preset'});
        this.presetsFilter.setOptions(presets);
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

    public setId(id){

        this.getTemplateViewModel().id(id)
    }
    public setName(name){

        this.getTemplateViewModel().name(name)
    }

    public setIsAvailable(isAvailable){

        this.getTemplateViewModel().isAvailable(isAvailable)
    }

    public setLoginStatus(status){

        this.filterLoginStatus.setSelectedOption(status);
    }

    public setPremiumStatus(status){

        this.filterPreimumStatus.setSelectedOption(status);
    }

    public setListItemStatus(status){

        this.filterListStatus.setSelectedOption(status);
    }

    public setHtml(htmlValue){

        this.getTemplateViewModel().htmlValue(htmlValue);
        this.vignettePreview.setHtml(htmlValue);
    }

    public setCss(cssValue){

        this.getTemplateViewModel().cssValue(cssValue);
        this.vignettePreview.setCss(cssValue);
    }

    public setContentType(contentType){

        this.getTemplateViewModel().contentType(contentType);
    }

    public setPreset(preset){

        this.presetsFilter.setSelectedOption(preset.id);
    }

    protected onClickCancel(): any {

        this.caller.onClickCancel();
    }

    protected onClickSave(): any {

        this.caller.save()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/configPromotionsEdit_template.ts